export enum LookupNames {
  nationality = 'Nationality',
  bloodType = 'BloodType',
  city = 'City',
  gender = 'Gender',
  jobType = 'JobType',
  area = 'Area',
  availableServices = 'AvailableServices',
  companyScale = 'CompanyScale',
  financeYear = 'FinanceYear',
  timeZone = 'TimeZone',
  companyType = 'companyType',
  shiftType = 'ShiftType',
  timeType = 'timeType',
  country='country'
}
